import { ordersBasketPersistedFormFetchRequested } from 'state/orders-basket/actions';
import type { OrdersBasketTabContent } from 'state/orders-basket/models';
import type { Thunk } from 'state/state.common';

import { ordersBasketTabContentAllFetched } from '../meta/meta.actions';
import { ordersBasketTabContentFetched } from './tabContent.actions';
import { isAllOrdersBasketTabContentsFetched } from './tabContent.selectors';

function hasProductTypeAndSubtype(
  tabContent: OrdersBasketTabContent,
): tabContent is OrdersBasketTabContent & { productType: string; productSubtype: string } {
  return (
    typeof tabContent.productType === 'string' &&
    typeof tabContent.productSubtype === 'string' &&
    !!tabContent.productType &&
    !!tabContent.productSubtype
  );
}

export function ordersBasketTabContentFetchedThunk(tabId: string, tabContent: OrdersBasketTabContent): Thunk<void> {
  return (dispatch, getState) => {
    dispatch(ordersBasketTabContentFetched(tabId, tabContent));

    const allTabContentFetched = isAllOrdersBasketTabContentsFetched(getState());
    if (allTabContentFetched) {
      dispatch(ordersBasketTabContentAllFetched());
    }

    if (!hasProductTypeAndSubtype(tabContent)) {
      return;
    }

    tabContent.negotiationIds.forEach(negotiationId => {
      dispatch(
        ordersBasketPersistedFormFetchRequested(
          negotiationId,
          tabContent.productType,
          tabContent.productSubtype,
          tabContent.wrapperType,
        ),
      );
    });
  };
}
